import { Modal } from '@seiue/ui'

import { EditTaskProps } from '../types'

import { EditQuestionnaireTaskModal } from './EditQuestionnaireTaskModal'

/**
 * 打开编辑问卷任务弹窗
 *
 * @param param0 - 参数
 * @param param0.taskId - 任务 ID
 * @param param0.activityId - 活动 ID
 * @param param0.activityTaskOptions - 活动选项
 */
export const openEditQuestionnaireTask = ({
  activityId,
  taskId,
  activityTaskOptions,
  domain,
}: EditTaskProps) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <EditQuestionnaireTaskModal
        onClose={() => {
          hide()
        }}
        taskId={taskId}
        activityId={activityId}
        activityTaskOptions={activityTaskOptions}
        domain={domain}
      />
    ),
  })
}
